import React from "react";

import Select from "components/shared/Select";

const MultiSelect = (props) => {
  return (
    <Select
      {...props}
      // Currently only md size is developed for multiselect
      baseClassName="lc-select-container--md lc-select-container--multi"
      isMulti
    />
  );
};

export default MultiSelect;
